<template>
  <div class="container">
    <div class="hello">
      <img
        id="logo"
        alt="Void Shelter Logo"
        src="../assets/images/VoidShelter_logo.png"
      />
      <hr />
      <p
        v-for="(item, index) in listDescriptions"
        v-bind:key="index"
        class="description"
        v-html="item.description"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Band",
  data() {
    return {
      listDescriptions: [
        {
          description:
            "A shelter. Your mind. Inside, an orderly and reassuring side, the other is hazy and tormented. Surrounded by emptiness symbolizing the unknown and the unconscious.",
        },
        {
          description:
            "Void Shelter creates its melancholic world by bringing to alternative rock visceral compositions, inspired by experiences and stories with surrealist texts. The group takes the public into an ambient, elegant and tortuous rock music, using its multiple inspirations.",
        },
        {
          description:
            "<ul><li>Vincent Laure</li><li>Antoine Poppe</li><li>Quentin Levavasseur</li><li>Quentin Poulichet</li><li>Tristan Gastinel</li>",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  padding: 30px;
}

.container {
  position: relative;
  width: 100%;
}

.container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/images/band-live-darken.jpg") no-repeat center
    center fixed;
  background-size: cover;
}
.hello {
  position: relative;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
}
hr {
  max-width: 40%;
}
#logo {
  margin: 0 auto;
  width: 450px;
  max-width: 100%;
}
.description {
  max-width: 600px;
  margin: 20px auto;
}
</style>
